module.exports = __webpack_public_path__ + "img/markerOnlineClose.f83912eb.png";